module.exports = __webpack_public_path__ + "img/fast.c82b3b1c.svg";